import request from '@/utils/request'

// 获取活动详情
export function getActivityInfo(data) {
  return request({
    url: 'index/Activity/info',
    method: 'get',
    params: data
  })
}

// 获取活动报名详情
export function getActivityEnroll(data) {
  return request({
    url: 'index/Activity/enroll',
    method: 'get',
    params: data
  })
}

// 新增活动
export function enrollAdd(data) {
  return request({
    url: 'index/Activity/enrollAdd',
    method: 'post',
    data: data
  })
}

// 获取用户报名记录
export function getUserApplyRecord(data) {
  return request({
    url: 'index/Activity/enrollRecord',
    method: 'get',
    params: data
  })
}

// 活动报名（非微信）
export function enrollUnsignedAdd(data) {
  return request({
    url: 'index/Activity/EnrollUnsignedAdd',
    method: 'post',
    data: data
  })
}

// 测试支付
export function wxPayTest(data) {
  return request({
    url: 'admin/TTest/wxPayTest',
    method: 'post',
    data: data
  })
}

// 字段记录
export function userAttributes(data) {
  return request({
    url: 'index/Activity/userAttributes',
    method: 'get',
    params: data
  })
}

// 发送验证码
export function phoneSMS(data) {
  return request({
    url: 'wechat/Base/phoneSMS',
    method: 'post',
    data: data
  })
}

// 绑定手机号
export function phoneLogin(data) {
  return request({
    url: 'index/User/phoneLogin',
    method: 'post',
    data: data
  })
}

export function orderCreat(data) {
  return request({
    url: 'index/Order/orderCreat',
    method: 'post',
    data: data
  })
}

// 获取用户手机号
export function getUserInfo(data) {
  return request({
    url: 'index/User/userInfo',
    method: 'get',
    params: data
  })
}

// 检查用户会员状态
export function checkMemberState(data) {
  return request({
    url: 'index/User/checkMemberState',
    method: 'post',
    data: data
  })
}

// 检查订单支付
export function checkOrder(data) {
  return request({
    url: 'Wechat/Base/wxPaySynchro',
    method: 'post',
    data: data
  })
}

// 检查支付宝订单
export function checkAliOrder(data) {
  return request({
    url: 'Wechat/Base/aliPaySynchro',
    method: 'post',
    data: data
  })
}

// 检查用户是否可以拥有老带新权限
export function checkPosterState(data) {
  return request({
    url: 'index/User/checkPosterState',
    method: 'get',
    params: data
  })
}
